/**
 * Not Found Page
 *
 * 404 page for invalid routes
 */

import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-mist flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-ink mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-ink mb-2">Page Not Found</h2>
        <p className="text-slate-600 mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-3 bg-accent text-white rounded-lg hover:bg-accent-dark transition font-semibold"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
